import { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { RetrievedChunk } from "../../types/logicChain";

interface RetrievedChunksProps {
  chunks: RetrievedChunk[];
}

export default function RetrievedChunks({ chunks }: RetrievedChunksProps) {
  const [expanded, setExpanded] = useState<string | null>(null);

  if (!chunks || chunks.length === 0) {
    return (
      <Box>
        <Typography variant="caption" sx={{ color: "#A99F8E", fontWeight: 600 }}>
          知识检索
        </Typography>
        <Typography variant="caption" sx={{ color: "#A99F8E", display: "block", mt: 0.5 }}>
          未触发检索或无可命中文本
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="caption" sx={{ color: "#A99F8E", fontWeight: 600 }}>
        知识检索 ({chunks.length} 条)
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
        {chunks.map((chunk, idx) => (
          <Card
            key={chunk.chunk_id || idx}
            variant="outlined"
            sx={{
              borderColor: "#E8E2D9",
              backgroundColor: "#FFF",
              borderRadius: 1.5,
            }}
          >
            <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="caption" sx={{ color: "#7C6F5C", fontWeight: 600 }}>
                  [{idx + 1}] {chunk.metadata?.source || "未知来源"}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Typography variant="caption" sx={{ color: "#A99F8E" }}>
                    匹配度: {(((chunk.score ?? chunk.hybrid_score ?? 0) as number) * 100).toFixed(1)}%
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() =>
                      setExpanded(expanded === chunk.chunk_id ? null : chunk.chunk_id || null)
                    }
                    sx={{ color: "#A99F8E", p: 0.3 }}
                  >
                    {expanded === chunk.chunk_id ? (
                      <ExpandLessIcon fontSize="small" />
                    ) : (
                      <ExpandMoreIcon fontSize="small" />
                    )}
                  </IconButton>
                </Box>
              </Box>
              <Collapse in={expanded === chunk.chunk_id}>
                <Typography
                  variant="caption"
                  sx={{ color: "#7C6F5C", mt: 1, display: "block", whiteSpace: "pre-wrap" }}
                >
                  {chunk.content}
                </Typography>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
